"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var R = _interopRequireWildcard(require("ramda"));
var _formik = require("formik");
var _fn = require("@otpusk/apisearch-toolbox/dist/queries/fn");
var _config = require("../../../../services/config");
var _Button = _interopRequireWildcard(require("../../../ui/Button"));
var _Label = _interopRequireDefault(require("../../../ui/Label"));
var _styles = _interopRequireDefault(require("./styles"));
var _excluded = ["getBackground"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var CATEGORIES = R.range(2, 6);
var injectFirstCategoryByCondition = function injectFirstCategoryByCondition(categoriesMap) {
  return R.assoc(1, categoriesMap[2], categoriesMap);
};
var excludeFirstCategory = function excludeFirstCategory(categoriesMap) {
  return R.omit([1], categoriesMap);
};
var getMinActiveCategory = function getMinActiveCategory(categoriesMap) {
  return R.call(R.pipe(R.toPairs, R.find(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      isActive = _ref2[1];
    return isActive;
  }), R.when(Boolean, function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 1),
      activeCategory = _ref4[0];
    return Number(activeCategory);
  })), categoriesMap);
};
var getMaxActiveCategory = function getMaxActiveCategory(categoriesMap) {
  return R.call(R.pipe(R.toPairs, R.findLast(function (_ref5) {
    var _ref6 = _slicedToArray(_ref5, 2),
      isActive = _ref6[1];
    return isActive;
  }), R.when(Boolean, function (_ref7) {
    var _ref8 = _slicedToArray(_ref7, 1),
      activeCategory = _ref8[0];
    return Number(activeCategory);
  })), categoriesMap);
};
var resetCategoriesMap = function resetCategoriesMap(categoriesMap) {
  return R.call(R.pipe(R.toPairs, R.map(function (_ref9) {
    var _ref0 = _slicedToArray(_ref9, 1),
      category = _ref0[0];
    return [category, false];
  }), R.fromPairs), categoriesMap);
};
var getActiveCategoriesRangeByMinCategory = function getActiveCategoriesRangeByMinCategory(categoriesMap, minCategory) {
  return R.call(R.pipe(R.toPairs, R.filter(function (_ref1) {
    var _ref10 = _slicedToArray(_ref1, 2),
      category = _ref10[0],
      active = _ref10[1];
    return category < minCategory && active;
  }), R.map(R.head)), categoriesMap);
};
var getActiveCategoriesRangeByMaxCategory = function getActiveCategoriesRangeByMaxCategory(categoriesMap, maxCategory) {
  return R.call(R.pipe(R.toPairs, R.filter(function (_ref11) {
    var _ref12 = _slicedToArray(_ref11, 2),
      category = _ref12[0],
      active = _ref12[1];
    return category > maxCategory && active;
  }), R.map(R.head)), categoriesMap);
};
var createCategoriesMapByRange = function createCategoriesMapByRange(range, categoriesMap) {
  return R.reduce(function (nextMap, category) {
    return R.assoc(category, true, nextMap);
  }, resetCategoriesMap(categoriesMap), range);
};
var generateNextCategoriesValues = function generateNextCategoriesValues(activeCategory, categoriesMap) {
  return categoriesMap[activeCategory] ? R.call(function (minRange, maxRange) {
    return createCategoriesMapByRange(minRange.length < maxRange.length ? maxRange : minRange, categoriesMap);
  }, getActiveCategoriesRangeByMinCategory(categoriesMap, activeCategory), getActiveCategoriesRangeByMaxCategory(categoriesMap, activeCategory)) : createCategoriesMapByRange(R.range(Math.min(activeCategory, getMinActiveCategory(categoriesMap) || Infinity), R.inc(Math.max(activeCategory, getMaxActiveCategory(categoriesMap) || -Infinity))), categoriesMap);
};
var getExternalProps = function getExternalProps(isActive) {
  return R.call(R.ifElse(Boolean, function (_ref13) {
    var getBackground = _ref13.getBackground,
      externalProps = _objectWithoutProperties(_ref13, _excluded);
    return _objectSpread({}, externalProps, {
      background: getBackground(isActive)
    });
  }, R.always({})), (0, _config.getCategoryControlInSearchForm)());
};
var CategoryControl = function CategoryControl() {
  var _useTranslation = (0, _reactI18next.useTranslation)('SEARCH_FORM'),
    t = _useTranslation.t;
  return /*#__PURE__*/_react.default.createElement(_Label.default, {
    clickable: false,
    text: t('CATEGORY_CONTROL_LABEL')
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.checkboxes
  }, /*#__PURE__*/_react.default.createElement(_formik.FastField, {
    name: _fn.QUERY_PARAMS.CATEGORY,
    render: function render(_ref14) {
      var field = _ref14.field,
        form = _ref14.form;
      return R.map(function (number) {
        return /*#__PURE__*/_react.default.createElement(_Button.default, _extends({
          key: number,
          size: _Button.SIZES.SMALL,
          theme: R.prop(number, field.value) ? _Button.THEMES.PURPLE : _Button.THEMES.GRAY,
          onClick: function onClick() {
            return form.setFieldValue(field.name, injectFirstCategoryByCondition(generateNextCategoriesValues(number, excludeFirstCategory(field.value))));
          }
        }, getExternalProps(R.prop(number, field.value))), "".concat(number, "*"));
      }, CATEGORIES);
    }
  })));
};
var _default = exports.default = CategoryControl;